module.exports = __webpack_public_path__ + "media/kuala lumpur/kl_towers-80398482.jpg";